export default "__VITE_ASSET__CWP17AcG__"